import clsx from 'clsx';
import { memo } from 'react';
import { Text } from 'Text';

function ImportantCtaBoxDescriptionComponent({ children, hasCta }: { children: React.ReactNode; hasCta: boolean }) {
    return (
        <div data-id="important-cta-box-description" className={clsx(hasCta && 'mb-5')}>
            <Text as="div" color="black" weight="normal" className="text-base">
                {children}
            </Text>
        </div>
    );
}

export const ImportantCtaBoxDescription = memo(
    ImportantCtaBoxDescriptionComponent,
) as typeof ImportantCtaBoxDescriptionComponent;
